import { Order } from '@spike/order-model';
import { FunctionComponent, useMemo } from 'react';
import { Title } from './Title';
import { getOrderStartTime, getOrderEndTime } from '../utils/OrderUtils';

export interface DateStartEndTimeProps {
    order: Order;
    className?: string;
}

export const DateStartEndTime: FunctionComponent<DateStartEndTimeProps> = props => {
    const start = useMemo(() => getOrderStartTime(props.order), [props.order]);

    const end = useMemo(() => getOrderEndTime(props.order), [props.order]);

    return (
        <Title
            title={
                (start === null ? '-' : `${start.format('dddd, D MMMM yyyy')} - ${start.format('h:mm A')}`) +
                (end === null ? '' : ` - ${end.format('h:mm A')}`)
            }
            className={props.className}
        />
    );
};

export default DateStartEndTime;
